import React, { useEffect, useState } from 'react';
import paw from '../assets/footprint.png';
import './styles/PawTrail.css';

const PawTrail = () => {
  const [scrollIndex, setScrollIndex] = useState(0);
  const totalPaws = 15;

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.scrollHeight - window.innerHeight;
      const scrollPercent = scrollTop / docHeight;
      const newIndex = Math.floor(scrollPercent * totalPaws);
      setScrollIndex(newIndex);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="paw-trail">
      {[...Array(totalPaws)].map((_, i) => {
        const offset = i % 2 === 0 ? -20 : 20;
        const isVisible = i <= scrollIndex && !(i === 0 && scrollIndex === 0); 

        return (
          <img
            key={i}
            src={paw}
            alt={`Paw ${i}`}
            className={`paw-step ${isVisible ? 'visible' : ''}`}
            style={{
              transform: `rotate(${180 + (i % 2 === 0 ? 15 : -15)}deg) scale(1) translateX(${offset}px)`
            }}
          />
        );
      })}
    </div>
  );
};

export default PawTrail;
